import React from 'react';
import IconNikeAI from '../IconNikeAI';
import { IconContainer } from './styles';

/**
 * Nike AI Header Icon
 * Entry point for variant-a: icon in header navigation
 * Triggers Nike AI toggle when clicked
 */
const NikeAIHeaderIcon = () => {
  const handleClick = () => {
    window.webShellClient?.__WS_INTERNAL__?.nikeAI?.toggle();
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      window.webShellClient?.__WS_INTERNAL__?.nikeAI?.toggle();
    }
  };

  return (
    <IconContainer
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      title="Nike AI"
    >
      <IconNikeAI ariaLabel="Nike AI Assistant" />
    </IconContainer>
  );
};

NikeAIHeaderIcon.displayName = 'NikeAIHeaderIcon';

export default NikeAIHeaderIcon;
